import AuthProvider, {
  useAuthContext,
  AuthContext,
} from './AuthenticationProvider';

export default AuthProvider;
export { useAuthContext, AuthContext };
